import { Component } from "@angular/core";

@Component({
  selector: 'app-informacoes-complementares',
  templateUrl: './informacoes-complementares.component.html',
  styleUrls: ['./informacoes-complementares.component.scss']
})
export class InformacoesComplementaresComponent {

}